import { z } from "zod";

export const personalApiKeyPrefix = "npak_";

export function isPersonalApiKey(token: string): boolean {
  return token.startsWith(personalApiKeyPrefix);
}

export const ApiKeyPermissionsSchema = z.object({
  /**
   * When present, the key may only read and write facts belonging to blocks in
   * these stacks. When absent, the key inherits its creator's role access
   */
  allowedStackIds: z.array(z.uuid()).optional(),

  /**
   * When true, changes to facts are not auto-approved, and instead require
   * manual approval by a human.
   */
  requireFactChangeApproval: z.boolean().optional().default(false),
});

export type ApiKeyPermissions = z.infer<typeof ApiKeyPermissionsSchema>;
